export default __webpack_public_path__ + "static/raluca_nicola-4153a69ccc057289f9df7ee55a196afa.jpg";